import React, { useState } from 'react';
import { supabase } from '../../services/supabaseClient';

export default function NuevaEmpresaAdmin() {
  const [nombreEmpresa, setNombreEmpresa] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [nombreAdmin, setNombreAdmin] = useState('');
  const [correoAdmin, setCorreoAdmin] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    try {
      // 1. Verificar si el correo ya está en usuarios
      const { data: existeUsuario, error: existeError } = await supabase
        .from('usuarios')
        .select('email')
        .eq('email', correoAdmin);

      if (existeError) throw existeError;

      if (existeUsuario && existeUsuario.length > 0) {
        setError('❌ El correo ya está registrado. Usa otro.');
        return;
      }

      // 2. Crear empresa
      const { data: empresaData, error: empresaError } = await supabase
        .from('empresas')
        .insert([{ nombre: nombreEmpresa, descripcion }])
        .select()
        .single();

      if (empresaError) throw empresaError;

      // 3. Crear usuario en Supabase Auth
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: correoAdmin,
        password: contrasena,
      });

      if (authError) throw authError;

      const uid = authData.user?.id;
      if (!uid) throw new Error("No se generó el usuario en Auth.");

      // 4. Insertar usuario en tabla usuarios
      const { error: usuarioError } = await supabase.from('usuarios').insert([
        {
          id_auth: uid,              // ⚡ campo que conecta con Supabase Auth
          nombre: nombreAdmin,
          email: correoAdmin,
          rol: 'admin',
          activo: true,
          empresa_id: empresaData.id,
        },
      ]);

      if (usuarioError) throw usuarioError;

      // ✅ Todo correcto
      setMensaje('✅ Empresa y administrador creados correctamente.');
      setNombreEmpresa('');
      setDescripcion('');
      setNombreAdmin('');
      setCorreoAdmin('');
      setContrasena('');
    } catch (err) {
      console.error(err);
      setError('❌ Error al crear empresa o usuario: ' + err.message);
    }
  };

  return (
    <div className="max-w-xl mx-auto bg-white shadow-md rounded p-6 mt-8">
      <h2 className="text-2xl font-bold text-blue-700 mb-4">
        Crear nueva empresa y administrador
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Empresa */}
        <div>
          <label className="block text-sm font-medium">Nombre de la Empresa</label>
          <input
            type="text"
            value={nombreEmpresa}
            onChange={(e) => setNombreEmpresa(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Descripción</label>
          <textarea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            className="w-full px-3 py-2 border rounded"
          ></textarea>
        </div>

        {/* Administrador */}
        <hr className="my-4" />
        <h3 className="text-lg font-semibold text-gray-700">Administrador principal</h3>

        <div>
          <label className="block text-sm font-medium">Nombre</label>
          <input
            type="text"
            value={nombreAdmin}
            onChange={(e) => setNombreAdmin(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Correo</label>
          <input
            type="email"
            value={correoAdmin}
            onChange={(e) => setCorreoAdmin(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Contraseña</label>
          <input
            type="password"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        {error && <p className="text-red-500 text-sm">{error}</p>}
        {mensaje && <p className="text-green-600 text-sm">{mensaje}</p>}

        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Crear empresa y administrador
        </button>
      </form>
    </div>
  );
}